import React, {useState, useEffect} from "react";
import {IoAddCircleOutline} from "react-icons/io5";
import {useSelector} from "react-redux";
import ModalConnectionType from "../../components/connection/ModalConnectionType";
import {createItem, deleteItem} from "../../services/service";
import {useNavigate} from "react-router-dom";
import DeleteButton from "../../components/DeleteButton";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import FillingDataTable from "../../components/FillingDataTable";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import TemDataTableInline from "../../components/TemDataTableInline";


const headerTable = [{
    name: "id", sort: false
}, {
    name: "priority", sort: true
}, {
    name: "icon", sort: false
}, {
    name: "name", sort: true
}, {
    name: "default", sort: false
}, <span className="sr-only">Edit</span>,];

const bodyTable = ["id", "priority", "icon", "name", "isDefault", "actions"];

const ConnectionTypeTable = ({
                                 id, selectedRowId, setSelectedRowId, setSpecificationRowId,
                             }) => {
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [data, setData] = useState({
        data: [], recordsTotal: 0, pageCount: 1,
    });
    const {t} = useTranslation();

    const fetchData = async () => {
        const response = await createItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/type/table`, token, {
            draw: 1,
            start: itemOffset,
            length: itemsPerPage,
            recordsTotal: 0,
            columns: [],
            order: [{column: sortColumn, dir: sortDir}],
            search: {value: "", regex: true},
            filter: {connectionId: id},
        });
        if (response.success) {
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id, name: item?.name, priority: item?.priority, icon: (<img
                        className="w-6 h-6 rounded-full "
                        src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/connection/${item.connectionTypeIndex}`}
                        alt={"img"}
                    />), isDefault: (<input
                        type="checkbox"
                        className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
                        checked={!!item.isDefault}
                        readOnly
                    />), actions: (<div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                        <DeleteButton onclick={() => handleDelete(item.id)}/>
                    </div>),
                };
            });

            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(response.data.recordsFiltered / parseInt(itemsPerPage)),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status, message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, data.recordsTotal]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset = (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const handleDelete = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`), text: t(`action.delete_item.text`), icon: "warning", buttons: {
                cancel: true, confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/type/${id}`, token);
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right", autoClose: 3000, closeOnClick: true, className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status, message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (<>
        <ModalConnectionType open={open} setOpen={setOpen} id={id} fetchData={fetchData}/>
        {isLoading ? (<h1>Loading...</h1>) : (<>
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t(`table.connection.connection_type`)}
                </h1>
            </div>
            <div className="flex items-center justify-between">
                <Select
                    setItemsPerPage={setItemsPerPage}
                    itemsPerPage={itemsPerPage}
                />
                <button
                    className="flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => setOpen(true)}
                >
                    {t('action.add')} {id}
                    <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                </button>
            </div>
            <TemDataTableInline
                data={data.data}
                bodyContent={bodyTable}
                headerTable={headerTable}
                rowHandler={(id) => {
                    if (id !== selectedRowId) {
                        setSelectedRowId(id);
                        setSpecificationRowId(null);
                    } else {
                        setSelectedRowId(id);
                    }
                }}
                sortFunction={sortFunction}
            />
            <Pagination
                handlePageClick={handlePageClick}
                pageCount={data.pageCount}
                forcePage={forcePage}
            />
        </>)}
    </>);
};

export default ConnectionTypeTable;
